import { useState } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { FaCalendar, FaUserTag, FaTimes } from 'react-icons/fa';

const TransactionFilters = ({ filters, onChange, onClose }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (field, value) => {
    setLocalFilters(prev => ({ ...prev, [field]: value }));
  };

  const applyFilters = () => {
    onChange(localFilters);
    onClose();
  };

  const resetFilters = () => {
    const reset = {
      startDate: null,
      endDate: null,
      transactionType: '',
      clientSearch: ''
    };
    setLocalFilters(prev => ({ ...prev, ...reset }));
    onChange(reset);
  };

  return (
    <Card className="mt-3 border shadow-sm">
      <Card.Header className="bg-white border-bottom-0 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <FaCalendar className="text-primary me-2" />
          <h6 className="mb-0 fw-semibold">Filtres avancés</h6>
        </div>
        <Button variant="link" onClick={onClose} className="p-0">
          <FaTimes />
        </Button>
      </Card.Header>
      
      <Card.Body>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Période de début</Form.Label>
              <Form.Control
                type="date"
                value={localFilters.startDate || ''}
                onChange={(e) => handleChange('startDate', e.target.value || null)}
              />
            </Form.Group>
          </Col>
          
          <Col md={6}>
            <Form.Group>
              <Form.Label>Période de fin</Form.Label>
              <Form.Control
                type="date"
                value={localFilters.endDate || ''}
                onChange={(e) => handleChange('endDate', e.target.value || null)}
              />
            </Form.Group>
          </Col>
          
          <Col md={6}>
            <Form.Group>
              <Form.Label>Type de transaction</Form.Label>
              <Form.Select
                value={localFilters.transactionType || ''}
                onChange={(e) => handleChange('transactionType', e.target.value)}
                className='account-type-select'
              >
                <option value="">Tous les types</option>
                <option value="Negociation">Négociation</option>
                <option value="Subscription">Souscription</option>
                <option value="Transfer">Transfert</option>
                <option value="Dividend">Dividende</option>
              </Form.Select>
            </Form.Group>
          </Col>
          
          <Col md={6}>
            <Form.Group>
              <Form.Label>Recherche client spécifique</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nom, prénom ou société"
                value={localFilters.clientSearch || ''}
                onChange={(e) => handleChange('clientSearch', e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
      
      <Card.Footer className="bg-white border-top-0 d-flex justify-content-between">
        <Button variant="outline-secondary" className='filter-button me-2' onClick={resetFilters}>
          Réinitialiser
        </Button>
        <div>
          <Button variant="outline-secondary" className='filter-button me-2 mb-1' onClick={onClose}>
            Annuler
          </Button>
          <Button variant="outline-secondary" className='filter-button me-2' onClick={applyFilters}>
            Appliquer les filtres
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default TransactionFilters;